import { gql } from '@apollo/client';

export const LIST_DATES_WITH_PUSH_TASK = gql`
    query ListDatesWithPushTask($startDate: LocalDate!, $endDate: LocalDate!, $warehouseId: Long!) {
        listDatesWithPushTask(startDate: $startDate, endDate: $endDate, warehouseId: $warehouseId)
    }
`;

export interface ListDatesWithPushTaskResponse {
    listDatesWithPushTask: string[];
}

export interface ListDatesWithPushTaskVariables {
    startDate: string;
    endDate: string;
    warehouseId: number;
}
